<div class="bgf-page etsy">
    <div class="bgf-page__header">
        <h1 class="bgf-page__title">
            <i class="fa-brands fa-etsy"></i>
            <span>Etsy boltok</span>
        </h1>
    </div>

    <button type="button" class="button is-link mb-4" [disabled]="loadingShops" (click)="updateAllOrders()">
        Összes shop megrendeléseinek frissítése
    </button>

    <!-- Meglévő shopok -->
    <div *ngFor="let shop of shops" class="bgf-form bgf-form--box etsy-form mb-5">
        <div class="is-flex is-justify-content-space-between is-align-items-center mb-3">
            <h2 class="title is-5 mb-0">
                {{ shop.name }}
                <i class="fa-solid fa-check has-text-success" *ngIf="shop.connected" title="Hitelesítve"></i>
                <span class="tag is-light ml-2" *ngIf="shop.shopId">shop_id: {{ shop.shopId }}</span>
            </h2>
            <button type="button" class="button is-small is-danger is-outlined" (click)="deleteShop(shop)">
                Törlés
            </button>
        </div>

        <div class="field">
            <label class="label">Bekapcsolva</label>
            <mat-slide-toggle
                color="primary"
                [(ngModel)]="shop.enabled"
                [disabled]="shop.updatingEnabled"
                [ngClass]="{'is-loading': shop.updatingEnabled}"
                (change)="toggleEnabled(shop, $event.checked)"
                [name]="'enabled-' + shop.id"
                [aria-label]="shop.enabled ? 'Bekapcsolva' : 'Nincs bekapcsolva'"
            >
            </mat-slide-toggle>
        </div>

        <div class="field">
            <label class="label">Név</label>
            <input class="input" type="text" [(ngModel)]="shop.name" [name]="'name-' + shop.id">
        </div>

        <div class="field">
            <label class="label">Keystring (App keystring / client_id)</label>
            <input class="input" type="text" [(ngModel)]="shop.keystring" [name]="'keystring-' + shop.id">
        </div>

        <div class="field">
            <label class="label">
                Shared Secret
                <span class="tag is-success is-light ml-2" *ngIf="shop.hasSharedSecret">beállítva</span>
                <span class="tag is-warning is-light ml-2" *ngIf="!shop.hasSharedSecret">hiányzik</span>
            </label>
            <input
                class="input"
                type="password"
                autocomplete="new-password"
                placeholder="{{ shop.hasSharedSecret ? '•••••• (csak csere esetén töltsd ki)' : 'Add meg a Shared Secretet' }}"
                [(ngModel)]="shop.sharedSecretInput"
                [name]="'secret-' + shop.id"
            >
        </div>

        <div class="field">
            <label class="label">Shop ID (számszerű – OAuth után automatikusan kitöltődik)</label>
            <input class="input" type="number" [(ngModel)]="shop.shopId" [name]="'shopid-' + shop.id">
        </div>

        <!-- Új Etsy appnál (új keystring) a callback URL-t az Etsy fejlesztői oldalán fel kell venni,
             különben a bejelentkezés után az Etsy hibát ír, és nem irányít vissza ide. -->
        <p class="help" style="margin-bottom: 0.6rem;">
            Új API kulcsnál az Etsy appban (Developers → Your Apps → Callback URLs) vedd fel pontosan ezt a címet:
            <code>{{ redirectUri }}</code> — és a bolt tulajdonos Etsy-fiókjával jelentkezz be.
        </p>

        <div class="control is-flex is-flex-wrap-wrap" style="gap: 0.5rem;">
            <button
                type="button"
                class="button is-info"
                [disabled]="shop.saving"
                [ngClass]="{'is-loading': shop.saving}"
                (click)="saveShop(shop)"
            >Mentés</button>

            <button type="button" class="button is-primary" [disabled]="!shop.keystring" (click)="connect(shop)">
                Bejelentkezés Etsy-vel
            </button>

            <button type="button" class="button" [disabled]="!shop.enabled" (click)="updateOrders(shop)">
                Megrendelések frissítése
            </button>

            <button
                type="button"
                class="button"
                [disabled]="!shop.enabled || shop.fetchingSkus"
                [ngClass]="{'is-loading': shop.fetchingSkus}"
                (click)="getUnknownSkus(shop)"
            >Ismeretlen SKU-k ellenőrzése</button>

            <button
                type="button"
                class="button"
                [disabled]="!shop.enabled || shop.importingImages"
                [ngClass]="{'is-loading': shop.importingImages}"
                (click)="importImages(shop)"
            >Képek importálása Etsy-ről</button>
        </div>

        <div *ngIf="shop.missingFromInventory?.length" class="mb-3 mt-3">
            <label>Etsy-ben bent van, de Inventoryban nincs:</label>
            <ul class="sku-list">
                <li *ngFor="let sku of shop.missingFromInventory">{{ sku }}</li>
            </ul>
        </div>
        <div *ngIf="shop.missingFromMerchant?.length" class="mb-3 mt-3">
            <label>Inventoryban bent van, de Etsy-ben nincs:</label>
            <ul class="sku-list">
                <li *ngFor="let sku of shop.missingFromMerchant">{{ sku }}</li>
            </ul>
        </div>
    </div>

    <!-- Új shop felvétele -->
    <form class="bgf-form bgf-form--box etsy-form">
        <label class="form-label">Új Etsy shop hozzáadása</label>
        <div class="field">
            <label class="label">Név</label>
            <input class="input" type="text" [(ngModel)]="newShopName" name="newShopName" placeholder="pl. BGFox második bolt">
        </div>
        <div class="field">
            <label class="label">Keystring</label>
            <input class="input" type="text" [(ngModel)]="newShopKeystring" name="newShopKeystring">
        </div>
        <div class="field">
            <label class="label">Shared Secret</label>
            <input class="input" type="password" autocomplete="new-password" [(ngModel)]="newShopSharedSecret" name="newShopSharedSecret">
        </div>
        <button
            type="button"
            class="button is-primary"
            [disabled]="!newShopName || creatingShop"
            [ngClass]="{'is-loading': creatingShop}"
            (click)="addShop()"
        >Shop hozzáadása</button>
    </form>
</div>
